import { useState, useEffect, useRef } from "react";

const NAVIGATION_ITEMS = [
  {
    id: "gallery",
    label: "Photos",
    mobilePrimary: true,
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    id: "visa",
    label: "Visa",
    mobilePrimary: false,
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 4.5A1.5 1.5 0 016.5 3h11A1.5 1.5 0 0119 4.5v15a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 015 19.5v-15z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12a3 3 0 116 0 3 3 0 01-6 0zM9 18h6" />
      </svg>
    ),
  },
  {
    id: "weather",
    label: "Weather",
    mobilePrimary: true,
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
      </svg>
    ),
  },
  {
    id: "budget",
    label: "Budget Overview",
    mobilePrimary: true,
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    id: "highlights",
    label: "Trip Highlights",
    mobilePrimary: true,
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
      </svg>
    ),
  },
  {
    id: "itinerary",
    label: "Day-wise Itinerary",
    mobilePrimary: true,
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    id: "hotels",
    label: "Hotel Recommendations",
    mobilePrimary: false,
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
  },
  {
    id: "notes",
    label: "Important Notes",
    mobilePrimary: false,
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    id: "packing",
    label: "Packing Checklist",
    mobilePrimary: false,
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
      </svg>
    ),
  },
];

const MOBILE_PRIMARY_ITEMS = NAVIGATION_ITEMS.filter((item) => item.mobilePrimary);
const MOBILE_MORE_ITEMS = NAVIGATION_ITEMS.filter((item) => !item.mobilePrimary);

const ItinerarySidebar = ({ requiresVisa = true, onEditTrip, onBackToDashboard, onGoToDashboard, onPlanAnotherTrip }) => {
  const [activeSection, setActiveSection] = useState("gallery");
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const moreMenuRef = useRef(null);

  const navItems = requiresVisa ? NAVIGATION_ITEMS : NAVIGATION_ITEMS.filter(i => i.id !== "visa");
  const mobileMoreItems = requiresVisa ? MOBILE_MORE_ITEMS : MOBILE_MORE_ITEMS.filter(i => i.id !== "visa");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (moreMenuRef.current && !moreMenuRef.current.contains(event.target)) {
        setShowMoreMenu(false);
      }
    };

    if (showMoreMenu) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showMoreMenu]);

  useEffect(() => {
    const handleScroll = () => {
      // getBoundingClientRect().top (viewport-relative) rather than
      // offsetTop (relative to each element's own nearest positioned
      // ancestor). Several of these sections sit inside differently
      // positioned wrappers, so their offsetTop values weren't actually
      // comparable to each other — that produced both a section staying
      // highlighted past its place on the page, and the highlight failing
      // to jump back to the top section when scrolling back up to it.
      const sections = NAVIGATION_ITEMS
        .map(item => {
          const element = document.getElementById(`section-${item.id}`);
          // getClientRects() is empty for a display:none element (e.g.
          // #section-visa when the trip needs no visa, via `empty:hidden`).
          // A hidden element's getBoundingClientRect() always reports
          // top: 0 regardless of its real position in the page, which — at
          // almost any scroll position — falsely looked like "just entered
          // view" and hijacked activeSection to an id with no visible nav
          // button, leaving every item unhighlighted.
          if (!element || element.getClientRects().length === 0) return null;
          return { id: item.id, top: element.getBoundingClientRect().top };
        })
        .filter(Boolean)
        .sort((a, b) => a.top - b.top);

      const threshold = 150; // px from the top of the viewport

      let current = sections[0]?.id;
      for (const section of sections) {
        if (section.top <= threshold) {
          current = section.id;
        } else {
          break;
        }
      }
      if (current) setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(`section-${sectionId}`);
    if (element) {
      // scrollIntoView + the section's own scroll-mt-* class (see
      // Itinerary.jsx) rather than computing a fixed target pixel here: a
      // one-shot `getBoundingClientRect() + window.scrollTo` reads the
      // layout once at click time, so any section whose height was still
      // settling (e.g. a collapsed accordion like Terms & Conditions right
      // before Packing Checklist) could leave the click undershooting its
      // target. scrollIntoView lets the browser itself resolve the target.
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <div className="hidden xl:block fixed left-0 top-20 bottom-0 z-30 w-60 bg-white border-r border-gray-200 overflow-y-auto scrollbar-hidden">
        <div className="p-4 space-y-1 h-full">
          <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider px-3 py-2">
            Quick Nav
          </p>
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className={`w-full cursor-pointer flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-200 group ${
                activeSection === item.id
                  ? "bg-teal-50 text-teal-700"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              }`}
            >
              <span className={`flex-shrink-0 ${
                activeSection === item.id ? "text-teal-600" : "text-gray-400 group-hover:text-gray-600"
              }`}>
                {item.icon}
              </span>
              <span className="text-sm font-medium">{item.label}</span>
              {activeSection === item.id && (
                <span className="ml-auto w-2 h-2 bg-teal-500 rounded-full flex-shrink-0"></span>
              )}
            </button>
          ))}
          {(onEditTrip || onBackToDashboard || onGoToDashboard || onPlanAnotherTrip) && (
            <div className="border-t border-gray-100 my-2"></div>
          )}
          {onEditTrip && (
            <button
              onClick={onEditTrip}
              className="w-full cursor-pointer flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-200 group bg-teal-600 text-white hover:bg-teal-700"
            >
              <span className="flex-shrink-0 text-white">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </span>
              <span className="text-sm font-medium">Modify Trip</span>
            </button>
          )}
          {onGoToDashboard && (
            <button
              onClick={onGoToDashboard}
              className="w-full cursor-pointer flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-200 group bg-teal-600 text-white hover:bg-teal-700"
            >
              <span className="flex-shrink-0 text-white">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </span>
              <span className="text-sm font-medium">Go to Dashboard</span>
            </button>
          )}
          {onPlanAnotherTrip && (
            <button
              onClick={onPlanAnotherTrip}
              className="w-full cursor-pointer flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-200 group text-gray-600 hover:bg-gray-50 hover:text-gray-900"
            >
              <span className="flex-shrink-0 text-gray-400 group-hover:text-gray-600">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
              </span>
              <span className="text-sm font-medium">Plan Another Trip</span>
            </button>
          )}
          {onBackToDashboard && (
            <button
              onClick={onBackToDashboard}
              className="w-full cursor-pointer flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-200 group text-gray-600 hover:bg-gray-50 hover:text-gray-900"
            >
              <span className="flex-shrink-0 text-gray-400 group-hover:text-gray-600">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
              </span>
              <span className="text-sm font-medium">Back to Dashboard</span>
            </button>
          )}
        </div>
      </div>

      <div className="xl:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 safe-area-pb">
        <div className="flex items-center justify-around py-2 px-1">
          {MOBILE_PRIMARY_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className={`flex flex-col items-center gap-0.5 px-2 py-1 rounded-lg transition-all ${
                activeSection === item.id
                  ? "text-teal-600"
                  : "text-gray-500"
              }`}
            >
              <span className={activeSection === item.id ? "text-teal-600" : "text-gray-400"}>
                {item.icon}
              </span>
              <span className="text-[9px] font-medium truncate max-w-[50px]">
                {item.label.split(" ")[0]}
              </span>
            </button>
          ))}
          <div className="relative" ref={moreMenuRef}>
            <button
              onClick={() => setShowMoreMenu(!showMoreMenu)}
              className={`flex flex-col items-center gap-0.5 px-2 py-1 rounded-lg transition-all ${
                showMoreMenu ? "text-teal-600" : "text-gray-500"
              }`}
            >
              <svg className={`w-4 h-4 ${showMoreMenu ? "text-teal-600" : "text-gray-400"}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
              </svg>
              <span className="text-[9px] font-medium">More</span>
            </button>
            {showMoreMenu && (
              <div className="absolute bottom-full right-0 mb-2 bg-white rounded-xl shadow-lg border border-gray-100 py-2 min-w-[160px] animate-fade-in">
                {mobileMoreItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => {
                      scrollToSection(item.id);
                      setShowMoreMenu(false);
                    }}
                    className={`w-full flex items-center gap-2 px-4 py-2.5 text-left transition-colors ${
                      activeSection === item.id
                        ? "bg-teal-50 text-teal-700"
                        : "text-gray-600 hover:bg-gray-50"
                    }`}
                  >
                    {item.icon}
                    <span className="text-sm whitespace-nowrap">{item.label}</span>
                  </button>
                ))}
                {(onEditTrip || onBackToDashboard || onGoToDashboard || onPlanAnotherTrip) && (
                  <div className="border-t border-gray-100 my-1"></div>
                )}
                {onEditTrip && (
                  <button
                    onClick={() => {
                      onEditTrip();
                      setShowMoreMenu(false);
                    }}
                    className="w-full flex items-center gap-2 px-4 py-2.5 text-left transition-colors text-teal-700 hover:bg-teal-50 font-medium"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    <span className="text-sm whitespace-nowrap">Modify Trip</span>
                  </button>
                )}
                {onGoToDashboard && (
                  <button
                    onClick={() => {
                      onGoToDashboard();
                      setShowMoreMenu(false);
                    }}
                    className="w-full flex items-center gap-2 px-4 py-2.5 text-left transition-colors text-teal-700 hover:bg-teal-50 font-medium"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                    <span className="text-sm whitespace-nowrap">Go to Dashboard</span>
                  </button>
                )}
                {onPlanAnotherTrip && (
                  <button
                    onClick={() => {
                      onPlanAnotherTrip();
                      setShowMoreMenu(false);
                    }}
                    className="w-full flex items-center gap-2 px-4 py-2.5 text-left transition-colors text-gray-600 hover:bg-gray-50"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                    <span className="text-sm whitespace-nowrap">Plan Another Trip</span>
                  </button>
                )}
                {onBackToDashboard && (
                  <button
                    onClick={() => {
                      onBackToDashboard();
                      setShowMoreMenu(false);
                    }}
                    className="w-full flex items-center gap-2 px-4 py-2.5 text-left transition-colors text-gray-600 hover:bg-gray-50"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    <span className="text-sm whitespace-nowrap">Back to Dashboard</span>
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ItinerarySidebar;
